export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff208a7ab81825b743e218a7dc7f0756d7a2422d7&name=fetchTypeahead!'